 window.addEventListener('load', () => {
    const targetElement = document.querySelector('fw-embed-feed.needsclick');

    if (targetElement.shadowRoot) {
      const style = document.createElement('style')
      style.textContent = `
      .cy-title {
            font-size: var(--font-heading-medium) !important;
            line-height: var(--font-line-height-heading-medium) !important;
            font-weight: 700 !important;
            font-family: var(--bold-font-family) !important;
            text-transform: uppercase;
      }
       
      .cy-grid {
        padding: 0 var(--gutter-container);
      }

       .cy-grid>div>div>div {
            width: 100%;
       }

       .cy-grid>div>div>div>div {
            aspect-ratio: 9 / 16;
            flex: 0 0 calc(100% / 4 - 10px * 3 / 4);
            height: auto;
            width: auto;
        }

        .cy-thumbnail-link .accessible-icon:first-child {
          background: rgba(64, 64, 64, 0.50);
          border-radius: 50%;
        }

        .cy-thumbnail-link .accessible-icon:first-child>div {
            transform: scale(0.6);
        }

        .cy-thumbnail-link .accessible-icon:first-child>div>svg>circle {
          fill: transparent;
        }

        .fw-thumbnail-caption {
          font-size: 15px !important;
        }

        @media (max-width: 1023px) and (min-width: 769px) {
          .cy-grid>div>div>div>div {
              flex: 0 0 calc(100% / 2.1 - 10px * 2 / 2.1);
          } 
        }

        @media(max-width: 768px) {
          .cy-grid>div>div>div>div {
              flex: 0 0 calc(100% / 1.2 - 10px * 2 / 1.2);
          }    
              .cy-title {
                font-size: var(--font-heading-medium) !important;
                line-height: var(--font-line-height-heading-medium) !important;
                font-weight: 700 !important;
                font-family: var(--bold-font-family) !important;
                text-transform: uppercase;
            }
              
          .cy-grid {
              padding: 0;
          }

        }

      `
      targetElement.shadowRoot.appendChild(style)
    }
  })